
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organisation-settings",
      function () {
        return require("private-next-pages/organisation-settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organisation-settings"])
      });
    }
  